import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import estilos from './ZonasComponent.module.css'
import { agregarZona, editarZona, sustituirInspector, eliminarInspectorDeZona, getZonas }
    from '../../../redux/DucksUnidadInspeccion/ZonasDuck';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux'

import { getInspectores } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import { insertZona, updateZona } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'


const ZonasFormZonasComponent = (props) => {

    const [openConfirmacionModal, setOpenConfirmacionModal] = React.useState(false);
    const handleOpenConfirmacionModal = () => setOpenConfirmacionModal(true);
    const handleCloseConfirmacionModal = () => setOpenConfirmacionModal(false);

    const [zonaNueva, setZonaNueva] = React.useState({})
    const [zonaAsignada, setZonaAsignada] = React.useState({})

    const inspectores = useSelector(store => store.Inspectores.inspectores)
    const zonas = useSelector(store => store.Zonas.zonas)

    const dispatch = useDispatch()

    const [zona, setZona] = React.useState('')

    //props de modificar
    const zonaModify = props.zonaModify

    const [inicialState, setInicialState] = useState({
        idzona: '',
        idinspector: 1,
        nombrezona: '',
        tipozona: 0,
        lng: '',
        lat: '',
    })

    const confirmarReAsignacion = () => {
        dispatch(eliminarInspectorDeZona(zonaAsignada))
        dispatch(insertZona(zonaNueva))
        handleCloseConfirmacionModal()
        props.onClose();
    }

    const validacionInspector = (zonax) => {
        const zonaAsignada = zonas.find(zona => zona.idinspector === zonax.idinspector)
        if (zonaAsignada) {
            setZonaNueva(zonax)
            setZonaAsignada(zonaAsignada)
            handleOpenConfirmacionModal()
        } else {
            //console.log('ZONA ENVIADA ES:' + JSON.stringify(zonax))
            dispatch(insertZona(zonax))
            props.onClose();
            
        }
    }

    React.useEffect(() => {
        dispatch(getInspectores())

    }, []);


    //Modificar
    React.useState(() => {
        if (zonaModify != null) {
            setInicialState({
                idzona: zonaModify.idzona,
                nombrezona: zonaModify.nombrezona,
                tipozona: zonaModify.tipozona,
                idinspector: zonaModify.idinspector,
                lat: zonaModify.lat,
                lng: zonaModify.lng
            })
        }
    }, [zonaModify])

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 500,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const confirmacionModal = () => {
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={openConfirmacionModal}
                onClose={handleCloseConfirmacionModal}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={openConfirmacionModal}>
                    <Box sx={style}>
                        <span>Este inspector ya se encuentra asignado a una zona <br /> Desea reasignarlo a la nueva zona? <br /><br /></span>
                        <button className='btn btn-lg btn-success' onClick={confirmarReAsignacion}>Confirmar</button>
                    </Box>
                </Fade>
            </Modal>
        )
    }

    return (
        <Fragment>
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ${estilos.contenedorBorder}`}>
                <div className='row'>
                    <h1 className={`${estilos.tituloForm}`}>{
                        zonaModify ?
                            "Editar Zona" :
                            "Registrar Zona"
                    }</h1>
                </div>

                <Formik
                    initialValues={inicialState}
                    validate={values => {
                        const errors = {};

                        return errors;
                    
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        if (zonaModify) {
                            console.log("Los valores son " + JSON.stringify(values))
                            const data = {
                                data: {
                                    idzona: Number(values.idzona),
                                    idinspector: Number(values.idinspector),
                                    nombrezona: values.nombrezona,
                                    tipozona: Number(values.tipozona),
                                    lng: values.lng,
                                    lat: values.lat
                                }
                            }
                            dispatch(updateZona(data))
                            props.actualizarZonas()
                            dispatch(getZonas())
                            props.onClose();
                            

                        } else {
                            const data = {
                                data: {                                                                    
                                    nombrezona: values.nombrezona,
                                    tipozona: Number(values.tipozona),
                                    lng: Number(values.lng),                                    
                                    lat: Number(values.lat)
                                }
                            }

                            dispatch(insertZona(data))
                            props.actualizarZonas()
                            props.onClose()
                            //validacionInspector(data)
                            dispatch(getZonas())
                        }
                        //setSubmitting(false);
                        props.onClose
                    }}
                >

                    {({ isSubmitting }) => (
                        <Form>
                            <div className={`container ${estilos.contenedorForm}`}>

                                <Field type="hidden" name="lng" className='form-control' />
                                <ErrorMessage name="lng" component="div" className={`${estilos.error}`} />

                                <Field type="hidden" name="lat" className='form-control' />
                                <ErrorMessage name="lat" component="div" className={`${estilos.error}`} />

                                <label htmlFor="nombrezona">Nombre de la zona:</label><br />
                                <Field type="text" name="nombrezona" className='form-control' />
                                <ErrorMessage name="nombrezona" component="div" className={`${estilos.error}`} /><br />

                                <label htmlFor="tipozona">Tipo de zona:</label><br />
                                <Field as="select" name="tipozona" className='form-control'>
                                    <option key={0} value='0'>Oaxaca</option>
                                    <option key={1} value='1' >Exterior </option>
                                </Field>

                                <ErrorMessage name="tipozona" component="div" className={`${estilos.error}`} /><br />


                                {/*<label htmlFor="noPeriodo">N° del periodo:</label><br />
                                <Field type="text" name="noPeriodo" className='form-control' />
                                <ErrorMessage name="noPeriodo" component="div" className={`${estilos.error}`} /><br />
                                */}

                                {/*<label htmlFor="intervaloPeriodo">Intervalo del periodo:</label><br />
                                <Field type="text" name="intervaloPeriodo" className='form-control' />
                                <ErrorMessage name="intervaloPeriodo" component="div" className={`${estilos.error}`} /><br />
                                */}

                                {/* <label htmlFor="idinspector">Inspector:</label><br />
                                <Field as="select" name="idinspector" className='form-control'>
                                    {
                                        inspectores.map((inspector, index) => (
                                            <option key={index} value={inspector.idinspector}>{inspector.nombre} {inspector.apellidos}</option>
                                        ))

                                    }
                                </Field> */}
                                <ErrorMessage name="idinspector" component="div" className={`${estilos.error}`} />

                                <div className='text-center'>
                                    <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                        {
                                            zonaModify ?
                                                "Guardar Cambios" :
                                                "Agregar Zona"
                                        }
                                    </button>
                                </div>

                            </div>
                        </Form>
                    )}

                </Formik>
            </div>
            {confirmacionModal()}
        </Fragment>
    )
}

export default withRouter(ZonasFormZonasComponent)